import React, { Component } from 'react'

class UserInfo extends Component {
  constructor (props) {
    super(props)
    this.levelClass = ''
    this.leveltxt = ''
    this.isVip = false
    this.levelurl = '//cps.youku.com/redirect.html?id=000145de'
  }
  render () {
    // const _gradeClass = `user-grade-lv${this.props.vipInfo.grade}`
    return (
      <div className='u-info'>
        <div className='u-avatar'>
          <a href={`//i.youku.com/i/${this.props.userInfo.encodeUid}`}target='_blank'>
            <img src={this.props.userInfo.avatar.middle} />
          </a>
        </div>
        <div className='u-profile'>
          <div className='u-name'>
            <a href={`//i.youku.com/i/${this.props.userInfo.encodeUid}`} className='u-link' target='_blank' title={this.props.userInfo.username}>{this.props.userInfo.username}</a>
          </div>
          {
            this.props.vipInfo && this.props.vipInfo.name
              ? (<div className='u-credit'>
                <a href='//cps.youku.com/redirect.html?id=000145de' target='_blank'>
                  <span className='vip-level-icon' title={this.props.vipInfo.name} style={{ backgroundImage: `url(${this.props.vipInfo.icon})` }} />
                </a>

                {/* <a className='user-grade'>
                  <span className={`user-grade-icon ${_gradeClass}`} title={`优酷等级：${this.props.vipInfo.grade}`} />
                </a> */}
                <a className='ico-valid-email ' href='//id.youku.com' target='_blank' />
                <a className='ico-valid-phone ico-valid-phone-done' href='//id.youku.com' target='_blank' />
              </div>) : <div className='u-credit'><a className='ico-valid-email ' href='//id.youku.com' target='_blank' />
                <a className='ico-valid-phone ico-valid-phone-done' href='//id.youku.com' target='_blank' />
              </div>
          }
        </div>
      </div>
    )
  }
}
export default UserInfo
